import { gql } from '@apollo/client';

// @TODO Rework these logics using userV2 [WWW-11898]
const UPGRADES = gql`
  query NumberOfUpgrades {
    user {
      id
      numberOfUpgrades
    }
  }
`;

export default UPGRADES;
